import { useCallback, useState } from 'react';
import { useToast } from '@/contexts/ToastContext';
import { toastError } from '@/lib/toastErrors';

export function useAsyncSave(toastKey: string) {
  const toast = useToast();
  const [saving, setSaving] = useState(false);

  const run = useCallback(
    async (fn: () => Promise<void>, successMessage: string) => {
      setSaving(true);
      try {
        await fn();
        toast.success(successMessage, toastKey);
      } catch (e) {
        toastError(toast, e, toastKey);
      } finally {
        setSaving(false);
      }
    },
    [toast, toastKey]
  );

  return { saving, run };
}
